import { createFromIconfontCN } from '@ant-design/icons'

const Icon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4771402_vokcndultba.js',
})

export default Icon
